export default __webpack_public_path__ + "static/media/3_001.3bd23fbf.png";